<template>
	<div class="user-profile">
		<el-form ref="form" :model="userProfile" :rules="rules">
            <el-row :gutter="8">
                <el-col :span="16">
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item prop="first_name" label="First Name">
                                <el-input :disabled="saving" v-model="userProfile.first_name"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="last_name" label="Last Name">
                                <el-input :disabled="saving" v-model="userProfile.last_name"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item prop="email" label="Email">
                                <el-input disabled v-model="userProfile.email"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="phone" label="Phone Number">
                                <el-input :disabled="saving" v-model="userProfile.phone"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10">
                        <el-col :span="12">
                            <el-form-item prop="timezone" label="Timezone">
                                <el-select :disabled="saving" class="w-100" v-model="userProfile.timezone">
                                    <el-option v-for="(timezone, key) in timezones" :key="key" :label="timezone" :value="timezone"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item prop="position" label="Position">
                                <el-input :disabled="saving" v-model="userProfile.position"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="8" class="d-flex flex-column align-content-center align-items-center justify-content-center">
                    <profile-image :edit="true" class="w-12"></profile-image>
                    <el-form-item prop="qr" label="Ambition Cloud Mobile App" class="mt-5 ml-5">
                        <qr-code :size="150" :text="appLoginDetails"></qr-code>
                    </el-form-item>
                </el-col>
            </el-row>
		</el-form>
        <el-button class="mt-5" ref="saveUserProfile" :disabled="saving" style="width: 200px" type="primary" @click="saveProfile">{{ saveText }}</el-button>
	</div>
</template>

<script>
    import VueQRCodeComponent from 'vue-qrcode-component'

	export default {
		name: "UserProfile",
        components: {
            'qr-code':VueQRCodeComponent,
        },
		data() {
			return {
                saving: false,
                saveText: "Save Profile",
                rules: {
					first_name: [{ required: true, message: "Required", trigger: "blur" }],
					last_name: [{ required: true, message: "Required", trigger: "blur" }],
					email: [{ required: true, message: "Required", trigger: "blur" }],
					phone: [{ required: true, message: "Required", trigger: "blur" }],
					timezone: [{ required: true, message: "Required", trigger: "change" }],
				},
			}
		},

        computed: {
            userProfile: {
                get() {
                    return this.$store.getters['user/user']
                },
                set(profile) {
                    this.$store.dispatch('user/setUser', profile)
                }
            },
            timezones() {
                return this.$store.getters['user/timezones']
            },
            appLoginDetails() {
                return btoa(JSON.stringify({
                    endpoint: _.get(this.Ambition.Globals.tenant, "tenant.Hostname"),
                    username: this.userProfile.email,
                    version: 'v2'
                }))
            }
        },

		methods: {
            saveProfile() {
                console.log('this.userProfile', this.userProfile)
                this.$refs.form.validate((valid) => {
					if (valid) {
                        this.saving = true
                        this.saveText = "Saving..."
                        axios.post('/admin/account/save-user-profile', this.userProfile)
                        .then(response => {
                            this.$notify({
                                title: 'Saved!',
                                message: 'Your profile was updated.'
                            });
                        })
                        .catch(err => {
                            this.$notify({
                                title: 'Error!',
                                message: 'There was an error while updating your profile. Please contact support.'
                            });
                        })
                        .finally(() => {
                            this.saving = false
                            this.saveText = "Save Profile"
                        })
                    }
                })
            }
        },
	}
</script>

<style lang="scss" scoped>
	.user-profile {
        padding: 50px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
	}

    .profile-image {
        padding: 20px;
        background: #ffffff;

        .profile-image-wrapper {
            .image-wrapper {
                margin-top: -107.5px;
            }
        }
    }
</style>
